<!-- Toggle Button for Mobile -->
<button class="toggle-btn" (click)="toggleSidebar()">☰</button>

<nav class="sidebar" [class.show]="sidebarOpen">
  <!-- Optional logo image -->
  <div class="sidebar-logo-wrapper">
    <img src="logo.png" alt="Hospital Logo" class="sidebar-logo" />
  </div>

  <h2 class="logo">🩺 OBULE STORE DASHBOARD</h2>

  <ul>
    <li><a routerLink="/admin/dashboard" routerLinkActive="active">📊 Dashboard</a></li>
    <li><a routerLink="/admin/stores" routerLinkActive="active">🏬 Main Store</a></li>
    <li><a routerLink="/admin/stock-items" routerLinkActive="active">📦 Stock Items</a></li>
    <li><a routerLink="/admin/manual-stock-log" routerLinkActive="active">✍️ Manual Stock Log</a></li>
    <li><a routerLink="/admin/wards" routerLinkActive="active">🛏️ Wards</a></li>
    <li><a routerLink="/admin/issue-drugs" routerLinkActive="active">💊 Dispensary</a></li>
    <li><a routerLink="/admin/patients" routerLinkActive="active">🧍‍♂️ Patients</a></li>
    <li><a routerLink="/admin/product-log" routerLinkActive="active">🧾 Product Logs</a></li>
    <li><a routerLink="/admin/store-info" routerLinkActive="active">🧍‍♂️ Store Info</a></li>
    <li><a (click)="confirmLogout()">🚪 Logout</a></li>
  </ul>
</nav>
